import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@environments/environment';
import { DOCUMENT } from '@angular/common';

interface IStatMosEventObject {
  action: string | any;
  fileType?: string;
  idDataset?: number;
}

export interface IStatMosBody {
  eventType: string;
  eventSrc?: string;
  eventDst: string;
  eventTime?: number;
  mosId?: string | null;
  eventObject?: IStatMosEventObject;
}
@Injectable({
  providedIn: 'root'
})
export class StatsMosService {
  private _defaultStatValues: IStatMosBody = {
    eventType: 'newDataMosRu',
    eventSrc: environment.siteUrl,
    eventDst: 'stats',
    mosId: null
  };
  constructor(private http: HttpClient, @Inject(DOCUMENT) private document: Document) {}

  private getMosId(): string | null {
    return this.document.cookie.replace(/(?:(?:^|.*;\s*)mos_id\s*=\s*([^;]*).*$)|^.*$/, '$1') || null;
  }

  public fireEvent(eventObject: IStatMosEventObject): Observable<any> {
    this._defaultStatValues.mosId = this.getMosId();
    this._defaultStatValues.eventTime = Math.round(Date.now() / 1000);
    this._defaultStatValues.eventObject = eventObject;
    const resultBody = encodeURIComponent(JSON.stringify(this._defaultStatValues));
    const url = `https://stats.mos.ru/eds.gif?o=${resultBody}`;
    return this.http.get(url);
  }

  public plainJS(eventObject: IStatMosEventObject): XMLHttpRequest {
    const data = encodeURIComponent(
      JSON.stringify({
        eventType: 'newDataMosRu',
        eventSrc: environment.siteUrl,
        eventDst: 'stats',
        eventObject: eventObject,
        mosId: null,
        eventTime: Math.round(Date.now() / 1000)
      })
    );

    const url = 'https://stats.mos.ru/eds.gif?o=';
    const request = new XMLHttpRequest();
    request.open('GET', `${url}${data}`);
    request.send();
    return request;
  }
}
